<template>
  <div class="order-confirm-contact">
    <div class="contact-header">
      <div class="header-title">订单联系人</div>
      <div class="header-sub-title">审核资料时，如需补交或修改资料时将联系此号码</div>
    </div>
    <div class="contact-content">
      <div class="contact-box">
        <div class="contract-name" :style="{width: `${otherOrderData.contact_name.length * 14 + 40}px`}">
          <input
            type="text"
            placeholder="姓名"
            @input="changeContactName"
            :maxlength="15"
            :value="otherOrderData.contact_name"
            @focus="onContactInputFocus('payvisaorder0name')"
          />
        </div>
        <div class="contact-phone">
          <input
            type="text"
            placeholder="联系人电话"
            @input="changeContactPhone"
            :maxlength="11"
            :value="otherOrderData.contact_phone"
            @focus="onContactInputFocus('payvisaorder0number')"
          />
        </div>
        <div class="contact-email" v-if="order.hide_return_address">
          <input
            type="text"
            placeholder="联系邮箱"
            @input="changeContactEmail"
            :maxlength="50"
            :value="otherOrderData.contact_email"
          />
        </div>
      </div>
      <div class="guest-box">
        <input
          type="text"
          placeholder="如有特殊要求，请留言"
          @input="changeGuestContent"
          :maxlength="100"
          :value="guest_content || otherOrderData.guest_content"
          @focus="onGuestContentFocus"
        />
      </div>
    </div>
  </div>
</template>
<script>
import globalData from '@/libs/global-data';

export default {
  name: '',
  props: {
    value: {
      type: Object,
      required: true,
      default: () => ({}),
    },
    // 订单
    order: {
      type: Object,
      required: true,
      default: () => ({}),
    },
  },
  data() {
    return {
      otherOrderData: this.value,
      guest_content: '',
    };
  },
  watch: {
    value(newVal) {
      this.otherOrderData = newVal;
    },
    order(newVal) {
      if (newVal.user_order_id) {
        this.guest_content = (globalData.guest_content && globalData.guest_content[this.order.user_order_id]) ? globalData.guest_content[newVal.user_order_id] : '';
      }
    },
  },
  created() {
  },
  methods: {
    // 统一处理
    changeModelData() {
      this.$emit('input', this.otherOrderData);
    },
    // 改变联系人名字
    changeContactName(e) {
      this.otherOrderData.contact_name = e.target.value;
      this.changeModelData();
    },

    // 改变联系人手机号
    changeContactPhone(e) {
      this.otherOrderData.contact_phone = e.target.value;
      this.changeModelData();
    },
    // 改变联系人手机号
    changeContactEmail(e) {
      this.otherOrderData.contact_email = e.target.value;
      this.changeModelData();
    },

    // 改变顾客留言
    changeGuestContent(e) {

      // 将顾客留言存储在全局变量中
      if (!globalData.guest_content) {
        globalData.guest_content = {};
      }
      this.otherOrderData.guest_content = globalData.guest_content[this.order.user_order_id] = e.target.value;
      this.changeModelData();
    },
    // 埋点需要
    onContactInputFocus(type) {
      MtaH5.clickStat(type);
    },
    // 埋点需要
    onGuestContentFocus() {
      MtaH5.clickStat('payvisaorder0message');
    },
  },
};
</script>
<style lang="less" scoped>
.order-confirm-contact{
  background: #fff;
  margin-top: 20px;
  .contact-header{
    height: 60px;
    display: flex;
    align-items: center;
    padding: 0 24px;
    .header-title{
      color: #2F333D;
      font-size: 20px;
      font-weight: 600;
      margin-right: 12px;
    }
    .header-sub-title{
      color: #91999F;
      font-size: 14px;
    }
  }

  .contact-content{
    padding: 0 24px 20px 24px;
    display: flex;
    input{
      outline: none;
      border: none;
      background: transparent;
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      padding: 0 20px;
      &::-webkit-input-placeholder{
        color: #91999F;
      }
    }
    .contact-box{
      flex-shrink: 0;
      display: flex;
      border-radius:2px;
      border:1px solid #DEE2E6;
      font-size: 14px;
      color: #2F333D;
      position: relative;
      min-width: 340px;
      max-width: 600px;
      .contract-name{
        min-width: 86px;
        max-width: 206px;
        height: 40px;
        position: relative;
        &::after{
          content: "";
          width:1px;
          height:16px;
          background: #DEE2E6;
          position: absolute;
          right: 0;
          top: 50%;
          transform: translateY(-50%);
        }
      }
      .contact-phone{
        min-width: 126px;
        flex-grow: 1;
        position: relative;
      }
      .contact-email{
        min-width: 250px;
        flex-grow: 2;
        position: relative;
        &::after{
          content: "";
          width:1px;
          height:16px;
          background: #DEE2E6;
          position: absolute;
          left: 0;
          top: 50%;
          transform: translateY(-50%);
        }
      }
    }
    .guest-box{
      margin-left: 30px;
      flex-grow: 1;
      border-radius:2px;
      border:1px solid #DEE2E6;
      font-size: 14px;
      color: #2F333D;
      position: relative;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/ordering/components/order-confirm-contact.vue